export const locale = {
  lang: 'tr',
  data: {
    'CONFIRMACION': {
      'FELICI':'¡TEBRİKLER, KONFİGÜRASYON SÜRECİNİN SONUNA GELDİNİZ!',
      'INDICACION':'Anketinizin aktif ve yapılandırılan tarihlerde uygulanmaya hazır olması için anketi etkinleştir butonuna tıklamanız gerekmektedir',
      'CONFIRMAR':'Anketi etkinleştir',
      'IND_CONFIRM_JP': 'Anketin etkinleştirilmesine devam etmeden önce, önceden yapılandırılmış bilgilerin onaylanması gerekir',
      'BTN_CONFIRM_INFO': 'Bilgileri onayla ',
      'IND_ESP_CONFIRM_JP':'Proje yöneticisi onayladığında, anketi etkinleştirmeye devam edeceğiz',
      'MOD_TIT_CONGR_CONF':'Onayınız için teşekkür ederiz',
      'MOD_ESP_CONFIRM_JP':'Anket aktivasyonuna devam etmek için sadece proje yöneticisinin onayına ihtiyacımız var',
      'CERRAR-CONFIRMAR':'Anketi devre dışı bırak',
      'MESSAGE5':'Uygulanmaya hazır aktif anket',
      'HISTORY_ACTIVATION_1': 'Son Aktivasyon / Devre Dışı Bırakma',
      'HISTORY_ACTIVATION_2': 'Aktivasyon geçmişi:',
      'ESTATUS_SURVEY':{
      '0':'Devre dışı bırakma',
      '1':'Aktivasyon',
      '2':'Kapalı',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>Anketin aktivasyonuna devam etmek için',
          // 'MESSAGE2':', metin kutusuna kırmızıyla metni girin</span>',
          'MESSAGE1':'<span> Anketi etkinleştirmeye devam etmek için metin kutusuna kırmızı metni girin: ',
          'MESSAGE2':'</span>',
          'SALIR': 'İptal etmek',
          'VALIDAR': 'Onaylamak',
          'ERRORNOMBREEMPRESA': 'Girilen metin, kırmızıyla gösterilen metinle eşleşmiyor',
          'SUCCES': 'Anket etkinleştirildi',
          'CERRAR': 'Kapat',
          'SUCCES-DES': 'Anket devre dışı bırakıldı',
          'MESSAGE3':'<span> Anketi devre dışı bırakmaya devam etmek için, metin kutusuna kırmızı metni girin ',
          'MESSAGE4':'</span>',
          'MESSAGE5':'Şu anda anketin sonuçları var, devre dışı bırakabileceğinizden emin misiniz?',
          'MESSAGE6':'Şu anda anket yok',
          'BTN-ACEPTAR': 'Kabul Et',
          'BTN-CANCELAR': 'İptal',
          'BTN-OK': 'Tamam ',
          'HORAMINIMA': 'E-posta ile iletişim onaylanamadı, gönderilecek ilk e-postanın tarihi (duruma göre başlatma veya ilk bildirim) bu andan itibaren iki saatten daha geç olmalıdır \n\nGerekirse tarihleri yeniden ayarlayın'
        },
        },
  },
  }
};
